<template>
  <v-app>
    <div class="bg"></div>
    <!-- <v-app-bar app light>
      <div class="d-flex align-center">
        <v-img
          class="shrink mr-2"
          contain
          :src="require('./assets/ibmlogo.png')"
          transition="scale-transition"
          height="100"
        />
        <v-img
          class="shrink mr-2"
          contain
          :src="require('./assets/ccllogo.png')"
          transition="scale-transition"
          height="100"
        />
        <v-img
          class="shrink mr-2"
          contain
          :src="require('./assets/nvslogo.png')"
          transition="scale-transition"
          height="100"
        />
        <v-img
          class="shrink mr-2"
          contain
          :src="require('./assets/vigyanjyotilogo.png')"
          transition="scale-transition"
          height="100"
        />
        <v-img
          class="shrink mr-2"
          contain
          :src="require('./assets/aiflogo.png')"
          transition="scale-transition"
          height="100"
        />
      </div>

      
    </v-app-bar> -->

    <v-main>
      <HelloWorld />
    </v-main>
  </v-app>
</template>

<script>
import HelloWorld from "./components/HelloWorld";

export default {
  name: "App",

  components: {
    HelloWorld,
  },

  data: () => ({
    //
  }),
};
</script>
<style scoped>
.bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url("./assets/bg2.png") no-repeat center center;
  background-size: cover;
  background-color: red;
  transform: scale(1.1);
  opacity: 0.3;
}
</style>
